import React from 'react'
import { Icon } from '@mobi/component-library/Common/Icon'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { formatKambiCurrencyWithThousandMultiplier } from '@core/Areas/Kambi/Components/BetHistory/helpers/currencyFormat'
import { CountdownStatus } from '../Common/CountdownStatus'

export const Single: React.FC<{
  ticket: BetLoopKambiShareCoupon
}> = ({ ticket }) => {
  const meetingName = ticket.events[0]?.eventName || 'Unknown Meeting'
  const heading = ticket.outcomes[0].label
  const subHeading = ticket.betOffers[0].criterion
  const priceWin = ticket.bets[0].betOdds

  return (
    <>
      <BetCard.EventDetails
        iconComponent={<Icon size='1.6rem' type='tab' />}
        heading={meetingName}
        statusComponent={<CountdownStatus ticket={ticket} />}
      />
      <BetCard.SelectionInfo
        iconComponent={<Icon size='1.6rem' type='tab' />}
        heading={heading}
        subHeading={subHeading}
        priceWin={formatKambiCurrencyWithThousandMultiplier(priceWin)}
      />
    </>
  )
}
